import React from 'react';
import { Alert } from '@spothero/ui';
const OversizeVehicleErrorAlert = ({ vehicle, }) => {
    return (<Alert status="error" description={`This facility cannot accommodate your ${vehicle?.display_description || 'vehicle'} due to size restrictions. Please refresh the page to see the search results.`} marginTop={-4} marginBottom={4} marginX={-4} padding={4} width="auto" data-testid="OversizeVehicleErrorAlert"/>);
};
export default OversizeVehicleErrorAlert;
